import Swiper from "swiper";
import SwiperCore, { Navigation, Pagination } from "swiper/core";
import Cookies from "js-cookie";
import { register } from "@shopify/theme-sections";
import { Ajaxinate } from "ajaxinate";

const initSwiper = (productGridItems) => {
  productGridItems.forEach((productGridItem) => {
    const swiperElement = productGridItem.querySelector(
      ".swiper-product-collection-images"
    );
    new Swiper(swiperElement, {
      pagination: {
        el: swiperElement.querySelector(".swiper-pagination"),
      },
    });
    productGridItem.dataset.swiperInitialized = true;
  });
};

register("collection_page", {
  onLoad() {
    SwiperCore.use([Navigation, Pagination]);
    const breakpoint = window.matchMedia("(min-width:768px)");

    const productGridItems = document.querySelectorAll(".product-grid-item");

    if (!breakpoint.matches) {
      initSwiper(productGridItems);
    }

    new Ajaxinate({
      container: "#bc-sf-filter-products",
      pagination: "#vPagination",
      callback: () => {
        Currency.convertAll("GBP", Cookies.get("currency") ?? "GBP");
        console.log("more stuff loaded");
        const productGridItems = document.querySelectorAll(
          ".product-grid-item:not([data-swiper-initialized])"
        );
        if (!breakpoint.matches) {
          initSwiper(productGridItems);
        }
      },
    });
  },
});
